"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var elog = require("@reverbdotcom/commons/dist/elog");
var lodash_1 = require("lodash");
var bind_1 = require("../../bind");
var adyen_checkout_mounter_1 = require("../adyen_checkout_mounter");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
exports.DEVICE_FINGERPRINT_CONTAINER_ID = 'threeds2-fingerprint';
var TAG = 'adyen.threeds2_identify_shopper';
var IdentifyShopper = /** @class */ (function (_super) {
    tslib_1.__extends(IdentifyShopper, _super);
    function IdentifyShopper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdentifyShopper.prototype.onComplete = function (result) {
        var fingerprintResult = lodash_1.get(result, ['data', 'details', 'threeds2.fingerprint']);
        this.props.onComplete(fingerprintResult);
    };
    IdentifyShopper.prototype.eventData = function (additionalContext) {
        if (additionalContext === void 0) { additionalContext = {}; }
        return {
            componentName: 'IdentifyShopper',
            context: tslib_1.__assign({ props: tslib_1.__assign({}, this.props) }, additionalContext),
        };
    };
    IdentifyShopper.prototype.componentDidMount = function () {
        adyen_checkout_mounter_1.mountComponent({
            domSelector: "#" + exports.DEVICE_FINGERPRINT_CONTAINER_ID,
            type: 'threeDS2DeviceFingerprint',
            locale: this.props.user.locale,
            props: {
                fingerprintToken: this.props.fingerprintToken,
                onComplete: this.onComplete,
                onError: this.props.onError,
            },
        });
        tracker_1.trackView(this.eventData());
        elog.info(TAG + ".mount", tslib_1.__assign({}, this.eventData()));
    };
    IdentifyShopper.prototype.render = function () {
        return React.createElement("div", { id: exports.DEVICE_FINGERPRINT_CONTAINER_ID });
    };
    tslib_1.__decorate([
        bind_1.default
    ], IdentifyShopper.prototype, "onComplete", null);
    return IdentifyShopper;
}(React.Component));
exports.IdentifyShopper = IdentifyShopper;
exports.default = user_context_provider_1.withUserContext(IdentifyShopper);
//# sourceMappingURL=identify_shopper.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/threeds2/identify_shopper.js
// module id = 77+W
// module chunks = 20 21 22